"use client";

import { useEffect } from "react";
import { capture, loadPosthog } from "@/lib/posthog";
import { whenIdle } from "@/lib/whenIdle";

const APP_HOSTS = new Set(["app.pandahub.com", process.env.NEXT_PUBLIC_CUSTOMER_APP_URL && new URL(process.env.NEXT_PUBLIC_CUSTOMER_APP_URL).host]);

const where = (el: Element) => (el.closest("nav") ? "header" : el.closest("footer") ? "footer" : "page");

// The clicks PostHog's autocapture doesn't name: phone calls, links into the booking app (Log in, Panda One) and the
// Chatbase bubble opening its window (their script is left alone). One listener on the document, as the price modal's.
function onClick(e: MouseEvent) {
  const target = e.target instanceof Element ? e.target : null;
  const link = target?.closest<HTMLAnchorElement>("a[href]");
  if (link?.protocol === "tel:") capture("call_tapped", { from: where(link) });
  else if (link && APP_HOSTS.has(link.host)) capture("app_link_tapped", { path: link.pathname, from: where(link) });
  else if (target?.closest("#chatbase-bubble-button") && !document.getElementById("chatbase-bubble-window")?.checkVisibility?.()) capture("chat_opened");
}

// After load, once the browser is idle (lib/whenIdle), so it never competes with first paint or the price window.
// Not on the first interaction: a visitor who leaves without touching the page is what we'd miss.
export default function Analytics() {
  useEffect(() => {
    const cancel = whenIdle(() => void loadPosthog());
    // capture phase: the chat window is read before Chatbase's own click handler toggles it
    document.addEventListener("click", onClick, true);
    return () => {
      cancel();
      document.removeEventListener("click", onClick, true);
    };
  }, []);
  return null;
}
